import React, { FC } from "react";
import Typography from "../../Unknown/Typography";
import { ConfirmedAppointment } from "../AppointmentConfirmedScreen/parseConfirmedAppointment";
import useTranslations from "./useTranslations";
import SuggestedPackageItem from "./SuggestedPackageItem";
import Grid from "../../Unknown/Grid";
import { SuggestedPackage } from "./useSuggestedPackages";

type SuggestedPackageListProps = {
  appointmentData: ConfirmedAppointment;
  suggestedPackages: SuggestedPackage[];
  onSelect: (packageId: string) => void;
  onDeselect: (packageId: string) => void;
};

const SuggestedPackageList: FC<SuggestedPackageListProps> = ({
  appointmentData,
  suggestedPackages,
  onSelect,
  onDeselect,
}) => {
  const {
    translations: { suggestedPackagesTitle },
  } = useTranslations();

  if (!suggestedPackages.length) return null;

  return (
    <Grid item xs={12}>
      <Typography variant="h3">{suggestedPackagesTitle}</Typography>
      {suggestedPackages.map((suggestedPackage) => {
        const {
          centerPackage,
          forOfferings,
          isSelected,
          isDisabled,
          priceDiff,
          upgradeOfferingPrice,
        } = suggestedPackage;
        const onSelectPackage = () => onSelect(centerPackage.id);
        const onDeselectPackage = () => onDeselect(centerPackage.id);

        return (
          <SuggestedPackageItem
            key={centerPackage.id}
            packageName={centerPackage.name}
            oldPrice={upgradeOfferingPrice}
            marketingText={centerPackage.marketingText || ""}
            offeringIds={forOfferings}
            isSelected={isSelected}
            isDisabled={isDisabled}
            appointmentData={appointmentData}
            priceDiff={priceDiff}
            onSelect={onSelectPackage}
            onDeselect={onDeselectPackage}
          />
        );
      })}
    </Grid>
  );
};

export default SuggestedPackageList;
